import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

function LanguageSwitcher(props) {
    const { setIsOpen } = props
    const { i18n } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        let lng = "th"
        let lang = searchParams.get("lang")
        console.log(lang)
        if (lang === "en") lng = "en-US"
        changeLanguage(lng, 'init')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const removeQueryParams = () => {
        // Get the current URL
        let url = new URL(window.location.href);

        // Get the query parameters
        let params = new URLSearchParams(url.search);

        // Remove the specified query parameter
        params.delete("lang");

        // Update the query parameters in the URL
        url.search = params;

        // Update the browser URL without causing a page refresh
        window.history.pushState({}, '', url);
    }

    const changeLanguage = (lng, state) => {
        if (lng === "th") removeQueryParams()
        else {
            searchParams.set("lang", "en")
            setSearchParams(searchParams)
        }
        localStorage.setItem("lang", lng)
        i18n.changeLanguage(lng);
        if (state === "click") setIsOpen(false)
    };

    return (
        <div>
            {
                searchParams.get("lang") && <div onClick={() => {
                    changeLanguage('th', 'click')

                }}><i className="fa-solid fa-flag"></i>&nbsp;&nbsp;Switch To: TH</div>
            }
            {
                !searchParams.get("lang") && <div onClick={() => {
                    changeLanguage('en-US', 'click')

                }}><i className="fa-solid fa-flag"></i>&nbsp;&nbsp;Switch To: EN</div>
            }
        </div>
    );
}

export default LanguageSwitcher;
